import { useState, useEffect } from 'react';
import { initIPFS, getFilesFromDirWithContent } from '../state/ipfs';

const useProjectMediaFiles = (projectData) => {
  const [isError, setIsError] = useState(false);
  const [icon, setIcon] = useState('');
  const [filesList, setFilesList] = useState([]);

  const getIcon = async (cid, signal) => {
    if (cid) {
      const ipfs = await initIPFS();
      const res = await getFilesFromDirWithContent(ipfs, cid, signal);
      if (res && res[0]?.content) {
        const blobImage = new Blob(res[0].content);
        const imageSrc = URL.createObjectURL(blobImage);
        return imageSrc;
      }
    }
    return '';
  };

  const getFiles = async (cid, signal) => {
    if (cid) {
      const ipfs = await initIPFS();
      const res = await getFilesFromDirWithContent(ipfs, cid, signal);
      if (res && res.length) return res;
    }
    return [];
  };

  useEffect(() => {
    if (!projectData) return;

    const controller = new AbortController();
    const signal = controller.signal;
    let isMounted = true;

    const { iconCidDir, secondIconCidDir, filesCidDir } = projectData;

    getIcon(secondIconCidDir || iconCidDir, signal)
      .then((data) => {
        if (isMounted) setIcon(data);
      })
      .catch(() => {
        if (isMounted) setIsError(false);
      });
    getFiles(filesCidDir, signal)
      .then((data) => {
        if (isMounted) setFilesList(data);
      })
      .catch(() => {
        if (isMounted) setIsError(false);
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [projectData]);

  return { isError, icon, filesList };
};

export default useProjectMediaFiles;
